'use client';

import { c as _c } from "react/compiler-runtime";
import { useApi } from '@repo/api';
import { useTableConfiguration } from '@repo/table/table-configuration';
import { useInfiniteQuery } from '@repo/tanstack/query';

/** One picker section, searched and paged by the server. Runs only while the panel is open. */
export const useSavedViewSection = t0 => {
  const $ = _c(13);
  const {
    access,
    enabled,
    search
  } = t0;
  const api = useApi();
  const {
    definition
  } = useTableConfiguration();
  let t1;
  if ($[0] !== access || $[1] !== api.tableConfigurations.savedViewsPages || $[2] !== definition.tableKey || $[3] !== search) {
    t1 = api.tableConfigurations.savedViewsPages.queryOptions({
      input: {
        access,
        perPage: 25,
        search: search || undefined
      },
      path: {
        tableKey: definition.tableKey
      }
    });
    $[0] = access;
    $[1] = api.tableConfigurations.savedViewsPages;
    $[2] = definition.tableKey;
    $[3] = search;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== enabled || $[6] !== t1) {
    t2 = {
      ...t1,
      enabled
    };
    $[5] = enabled;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const query = useInfiniteQuery(t2);
  let t3;
  if ($[8] !== query.data?.pages) {
    t3 = query.data?.pages.flatMap(_temp) ?? [];
    $[8] = query.data?.pages;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== query || $[11] !== t3) {
    t4 = {
      ...query,
      items: t3
    };
    $[10] = query;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
function _temp(page) {
  return page.data;
}